import React from 'react';
import { Link } from 'react-router-dom';
import { formatBlogDate, truncateText } from '../../api/blogApi';
import './BlogCard.scss';

const BlogCard = ({ blog }) => {
    const { title, excerpt, content, target_keywords, language, created_at, status, slug } = blog;
    
    // Get the first keyword as category, or use a default
    const category = target_keywords && target_keywords.length > 0 
        ? target_keywords[0] 
        : 'Dental Care';
    
    // Format the date
    const formattedDate = formatBlogDate(created_at);
    const dateObj = new Date(created_at);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleDateString('en-US', { month: 'short' });
    
    // Get excerpt or truncate content
    const displayExcerpt = excerpt || truncateText(content, 120);
    
    // Language display
    const languageNames = {
        en: 'English', hi: 'Hindi', gu: 'Gujarati', mr: 'Marathi',
        ta: 'Tamil', te: 'Telugu', kn: 'Kannada', ml: 'Malayalam',
        bn: 'Bengali', pa: 'Punjabi'
    };
    
    const languageName = languageNames[language] || language;

    return (
        <div className='col-lg-4 col-md-6 col-sm-6'>
            <div className="blog-card">
                <div className="blog-img">
                    {/* Placeholder image with dental theme */}
                    <div className="dental-icon">
                        <i className="fas fa-tooth"></i>
                    </div>
                    <div className="date">
                        <h6>{day}</h6>
                        <p>{month}</p>
                    </div>
                    {status === 'published' && (
                        <div className="status-badge published">
                            <i className="fas fa-check"></i>
                        </div>
                    )}
                    {status === 'draft' && (
                        <div className="status-badge draft">
                            <i className="fas fa-edit"></i>
                        </div>
                    )}
                </div>
                <div className="blog-text">
                    <div className="blog-meta">
                        <span className="category">
                            <Link to="/">{category}</Link>
                        </span>
                        <span className="language">
                            <i className="fas fa-globe"></i> {languageName}
                        </span>
                    </div>
                    <h3>
                        <Link to={`/blog/${slug || blog.id}`}>
                            {title}
                        </Link>
                    </h3>
                    <p>{displayExcerpt}</p>
                    
                    {/* Keywords display */}
                    {target_keywords && target_keywords.length > 0 && (
                        <div className="keywords">
                            {target_keywords.slice(0, 3).map((keyword, index) => (
                                <span key={index} className="keyword-tag">
                                    {keyword}
                                </span>
                            ))}
                            {target_keywords.length > 3 && (
                                <span className="keyword-more">
                                    +{target_keywords.length - 3}
                                </span>
                            )}
                        </div>
                    )}
                    
                    <div className="blog-footer">
                        <span className="date-text">
                            <i className="fas fa-calendar"></i> {formattedDate}
                        </span>
                        <Link to={`/blog/${slug || blog.id}`} className="read-more">
                            Read More <i className="fas fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;